import { NavController } from 'ionic-angular';
import { CoinsProvider } from './../../providers/coins/coins';
import { Coin, PriceFullRaw } from './../../models/Coin';
import { Component, ViewChild, Input, ElementRef, ChangeDetectorRef, OnChanges} from '@angular/core';

/**
 * Generated class for the WatchlistItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'watchlist-item',
  templateUrl: 'watchlist-item.html'
})
export class WatchlistItemComponent implements OnChanges {
  @ViewChild('chartCol') chartCol: ElementRef;
  @Input('coin') coin: Coin;
  @Input('price') price: PriceFullRaw;
  @Input('interval') interval: string;
  @Input('showChart') showChart: boolean;

  pctChange: number;
  chartWidth: number;
  chartHeight: number;

  WIDTH_BUFFER = 30;
  constructor(
    public CP: CoinsProvider,
    public cdRef: ChangeDetectorRef,
    public navCtrl: NavController)
  {
    
  }

  ngOnInit(){
    this.pctChange = 0;
  }

  ngAfterViewInit(){
    if(this.showChart){
      this.chartWidth = this.chartCol.nativeElement.clientWidth;
      this.chartHeight = 50;
    }
  }

  ngOnChanges(changes){

    setTimeout(() => {
      if(this.showChart && this.chartCol){
        this.chartWidth = this.chartCol.nativeElement.clientWidth;
        this.chartHeight = 50;
      }
    }, 0)

  }
  ngAfterViewChecked(){
    this.cdRef.detectChanges();
  }

  goToCoin(event: Event){
    event.stopPropagation();
    let params = {
      // coin: coin,
      'coinName': this.coin.Name
    }
    this.navCtrl.push('CoinPage', params);
  }

  stopProp(event: Event){
    event.stopPropagation();
  }
  setChange(change){
    this.pctChange = change;
  }
}



// WEBPACK FOOTER //
// ./src/components/watchlist-item/watchlist-item.ts